export function dayofMonth(Year, itemMonth) {
  //let names = Object.freeze(['Sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']);
  let date = new Date(Year, itemMonth - 1, 1);
  let result = [];
  while (date.getMonth() === itemMonth - 1) {
    result.push(`${date.getDate()}`);
    date.setDate(date.getDate() + 1);
  }
  return `${result}`;
}

export function dateRange(startDate, endDate) {
  var start = startDate.split("-");
  var end = endDate.split("-");
  var startYear = parseInt(start[0]);
  var endYear = parseInt(end[0]);
  var dates = [];

  for (var i = startYear; i <= endYear; i++) {
    var endMonth = i !== endYear ? 11 : parseInt(end[1]) - 1;
    var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
    for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
      var month = j + 1;
      var displayMonth = month < 10 ? "0" + month : month;
      dates.push([displayMonth].join("-"));
    }
  }
  return dates;
}
//convert number to string
export function get_Month(No_Mes) {
  var name_month;
  if (typeof (No_Mes === Number)) {
    if (No_Mes === 1) {
      name_month = "ENE";
    }
    if (No_Mes === 2) {
      name_month = "FEB";
    }
    if (No_Mes === 3) {
      name_month = "MAR";
    }
    if (No_Mes === 4) {
      name_month = "ABR";
    }
    if (No_Mes === 5) {
      name_month = "MAY";
    }
    if (No_Mes === 6) {
      name_month = "JUN";
    }
    if (No_Mes === 7) {
      name_month = "JUL";
    }
    if (No_Mes === 8) {
      name_month = "AUG";
    }
    if (No_Mes === 9) {
      name_month = "SEP";
    }
    if (No_Mes === 10) {
      name_month = "OCT";
    }
    if (No_Mes === 11) {
      name_month = "NOV";
    }
    if (No_Mes === 12) {
      name_month = "DEC";
    }
  }
  if (typeof (No_Mes === String)) {
    if (No_Mes === "ENE") {
      name_month = "ENERO";
    }
    if (No_Mes === "FEB") {
      name_month = "FEBRERO";
    }
    if (No_Mes === "MAR") {
      name_month = "MARZO";
    }
    if (No_Mes === "ABR") {
      name_month = "ABRIL";
    }
    if (No_Mes === "MAY") {
      name_month = "MAYO";
    }
    if (No_Mes === "JUN") {
      name_month = "JUNIO";
    }
    if (No_Mes === "JUL") {
      name_month = "JULIO";
    }
    if (No_Mes === "AUG") {
      name_month = "AGOSTO";
    }
    if (No_Mes === "SEP") {
      name_month = "SEPTIEMBRE";
    }
    if (No_Mes === "OCT") {
      name_month = "OCTUBRE";
    }
    if (No_Mes === "NOV") {
      name_month = "NOVIEMBRE";
    }
    if (No_Mes === "DEC") {
      name_month = "DICIEMBRE";
    }
  }
  return name_month;
}

export function graphics_produccion_vs_Despacho(element) {
  var source_data_production;

  if (element.Mes === "ENE") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "FEB") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "MAR") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "ABR") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "MAY") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "JUN") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "JUL") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "AUG") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "SEP") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "OCT") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "NOV") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  if (element.Mes === "DEC") {
    source_data_production = {
      previous: element.previous,
      Mes: element.Mes,
      today: element.today,
      NoMes: element.NoMes,
    };
  }
  return source_data_production;
}

export function groupByMonth(miarray, prop) {
  return miarray.reduce(function (groups, item) {
    var val = item[prop];
    groups[val] = groups[val] || {
      date: item.date,
      previous: item.previous,
      today: item.today,
      Mes: item.Mes,
      Periodo: item.Periodo,
      NoMes: item.NoMes,
    };
    return groups;
  }, {});
}

//convert number to string
export function get_Month_Name(No_Mes) {
  var name_month;

  if (No_Mes === 1) {
    name_month = "ENERO";
  }
  if (No_Mes === 2) {
    name_month = "FEBRERO";
  }
  if (No_Mes === 3) {
    name_month = "MARZO";
  }
  if (No_Mes === 4) {
    name_month = "ABRIL";
  }
  if (No_Mes === 5) {
    name_month = "MAYO";
  }
  if (No_Mes === 6) {
    name_month = "JUNIO";
  }
  if (No_Mes === 7) {
    name_month = "JULIO";
  }
  if (No_Mes === 8) {
    name_month = "AGOSTO";
  }
  if (No_Mes === 9) {
    name_month = "SEPTIEMBRE";
  }
  if (No_Mes === 10) {
    name_month = "OCTUBRE";
  }
  if (No_Mes === 11) {
    name_month = "NOVIEMBRE";
  }
  if (No_Mes === 12) {
    name_month = "DICIEMBRE";
  }

  return name_month;
}

export function get_Details(data, code) {
  const data_subColumns = data;
  var details_report = [];
  data_subColumns.forEach((element) => {
    if (element.DraftEntry === parseInt(code)) {
      details_report.push(element);
    }
  });
  return details_report;
}

export function suma_proyectos_macizo(arr) {
  const data = arr;
  var obj = {};
  var suma_U_Cantidad = 0;
  var suma_U_CostoUnitario = 0;
  var suma_OutQty = 0;
  var suma_CalcPrice = 0;
  var suma_porcentaje = 0;
  data.forEach((element) => {
    suma_U_Cantidad += element.U_Cantidad;
    suma_U_CostoUnitario += element.U_CostoUnitario;
    suma_OutQty += element.OutQty;
    suma_CalcPrice += element.CalcPrice;
    suma_porcentaje += element.porcentaje;
    obj = {
      Cuenta: "--",
      U_FaceProyecto: "--",
      Nombre_Cuenta: "--",
      Name: "TOTAL",
      ItemCode: "--",
      Dscription: "--",
      U_Cantidad: suma_U_Cantidad,
      U_CostoUnitario: suma_U_CostoUnitario,
      OutQty: suma_OutQty,
      CalcPrice: suma_CalcPrice,
      porcentaje: suma_porcentaje,
    };
  });
  return obj;
}
//convert number to string
export function get_No_Month(No_Mes) {
  var no_month;

  if (No_Mes === "ENERO") {
    no_month = 1;
  }
  if (No_Mes === "FEBRERO") {
    no_month = 2;
  }
  if (No_Mes === "MARZO") {
    no_month = 3;
  }
  if (No_Mes === "ABRIL") {
    no_month = 4;
  }
  if (No_Mes === "MAYO") {
    no_month = 5;
  }
  if (No_Mes === "JUNIO") {
    no_month = 6;
  }
  if (No_Mes === "JULIO") {
    no_month = 7;
  }
  if (No_Mes === "AGOSTO") {
    no_month = 8;
  }
  if (No_Mes === "SEPTIEMBRE") {
    no_month = 9;
  }
  if (No_Mes === "OCTUBRE") {
    no_month = 10;
  }
  if (No_Mes === "NOVIEMBRE") {
    no_month = 11;
  }
  if (No_Mes === "DICIEMBRE") {
    no_month = 12;
  }
  return no_month;
}

export function SumaHours(timeMap, Hour, Sec) {
  var totalH = timeMap;
  var totalM = Hour;
  // First simply adding all of it together, total hours and total minutes
  for (var x in timeMap) {
    totalH += parseInt(timeMap[x].hour, 10);
    totalM += parseInt(timeMap[x].minutes, 10);
  }
  // If the minutes exceed 60
  if (totalM >= 60) {
    // Divide minutes by 60 and add result to hours
    totalH += Math.floor(totalM / 60);
    // Add remainder of totalM / 60 to minutes
    totalM = totalM % 60;
  }
  return totalH + "." + totalM;
}

export function PorcentaHours(/* Hours */ Hour, Sec) {
  //var Hour = parseInt(Hours.split(' ')[0].split('.')[0]);
  //var Sec = parseInt(Hours.split(' ')[0].split('.')[1]);
  var totalH = Hour;
  var totalM = (Sec * 3600) / 60;
  //var porcentajeSeconds = parseInt(totalM / 100);
  var d = totalM.toString();
  // var t = d.length === 3 ? '0' + d : d;
  var m = d.slice(0, 2);
  var real = "";
  if (parseInt(m) > 60) {
    var r = "0" + d;
    real = r.slice(0, 2);
  }
  if (parseInt(m) <= 60) {
    real = m;
  }

  return totalH + "." + real;
}

export function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

export function trunc(x, posiciones = 0) {
  var s = x !== null ? x.toString() : "";
  var decimalLength = s.indexOf(".") + 1;
  var numStr = s.substr(0, decimalLength + posiciones);
  return Number(numStr);
}

export function TableHome(
  U_NombrePlanta,
  proyeccion,
  U_Cantidad,
  metaCiclos,
  proyeccionCiclos
) {
  var total = 0;

  if (
    U_NombrePlanta.trim() === "PAE" ||
    U_NombrePlanta.trim() === "TEJAS" ||
    U_NombrePlanta.trim() === "Subtotal Planta Tejas" ||
    U_NombrePlanta.trim() === "PAX" ||
    (U_NombrePlanta.trim() === "Subtotal SI" &&
      Number.isNaN((proyeccion / U_Cantidad) * 100) === false &&
      Number.isFinite((proyeccion / U_Cantidad) * 100) === true)
  ) {
    total = Math.round((proyeccion / U_Cantidad) * 100);
  }
  if (
    Number.isNaN((proyeccionCiclos / metaCiclos) * 100) === false &&
    Number.isFinite((proyeccionCiclos / metaCiclos) * 100) === true
  ) {
    total = Math.round((proyeccionCiclos / metaCiclos) * 100);
  }
  return total;
}

export function ColorHome(planta) {
  var color = "#000000";
  if (planta === "CDA") {
    color = "#EE5C2D";
  }
  if (planta === "CKC-K1") {
    color = "#EE882D";
  }
  if (planta === "CKC-K2") {
    color = "#F1A90F";
  }
  if (planta === "CKC-K3") {
    color = "#F9E010";
  }
  if (planta === "CKC-K4") {
    color = "#CEF50C";
  }
  if (planta === "CKC-K5") {
    color = "#81F50C";
  }
  if (planta === "PAE") {
    color = "#0CF5C4";
  }
  if (planta === "PAR") {
    color = "#0CEAF5";
  }
  if (planta === "PAX") {
    color = "#0C99F5";
  }
  if (planta === "PVC") {
    color = "#0C25F5";
  }
  if (planta === "PVE") {
    color = "#A370F7";
  }
  if (planta === "PVE2") {
    color = "#F50CCE";
  }
  if (planta === "PVG") {
    color = "#F50C64";
  }
  if (planta === "PVR") {
    color = "#BEA6AF";
  }
  if (planta === "PVX") {
    color = "#8B8F69";
  }
  if (planta === "TEJAS") {
    color = "#C1AD68";
  }
  if (planta === "PVR2") {
    color = "#AEAEAE";
  }
  return color;
}

export function FormatHours(Hour, Sec) {
  var totalH = Hour;
  if (Sec.toString().length === 1) {
    let totalM = (`0.0${Sec}` * 3600) / 60;
    let d = totalM.toString();

    var frgSplit = d.split(".");
    var resultSplit = frgSplit[0];
    let m = resultSplit.slice(0, 2);
    var real = "";
    if (m.toString().length === 1) {
      let r = "0" + d;
      real = r.slice(0, 2);
    }
    if (m.toString().length > 1) {
      real = m;
    }
    return totalH + ":" + real;
  }
  if (Sec.toString().length > 1) {
    let totalM = (Sec * 3600) / 60;
    let d = totalM.toString();
    let m = d.slice(0, 2);

    var realS = "";
    if (parseInt(m) > 60) {
      var r = "0" + d;
      realS = r.slice(0, 2);
    }
    if (parseInt(m) <= 60) {
      realS = m;
    }
    return totalH + ":" + realS;
  }
}

export function replace_value(value) {
  let valor = value;
  valor = valor.toString().replace(/\./g, ":");
  return valor;
}

export function FunctionPromedioHoras(arrayDates, Items) {
  let arr = arrayDates;
  let sumaDate = 0;
  arr.forEach((res) => (sumaDate += res));
  var resultPromedio = new Date(sumaDate / Items);
  let minutes = resultPromedio.getMinutes().toString();
  let minutesFormato = minutes.length === 1 ? "0" + minutes : minutes;
  let obj = {
    resultFormatHour: resultPromedio.getHours() + ":" + minutesFormato,
    resultFormatFloat: resultPromedio.getHours() + "." + minutesFormato,
  };
  return obj;
}

export function calculardiferenciaHoras(hrsInicio, hrsFinal) {
  var hora_inicio = hrsInicio;
  var hora_final = hrsFinal;

  var formatohora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

  if (!(hora_inicio.match(formatohora) && hora_final.match(formatohora))) {
    return;
  }

  // Calcula los minutos de cada hora
  var minutos_inicio = hora_inicio
    .split(":")
    .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
  var minutos_final = hora_final
    .split(":")
    .reduce((p, c) => parseInt(p) * 60 + parseInt(c));

  // Si la hora final es anterior a la hora inicial sale
  if (minutos_final < minutos_inicio) return;

  // Diferencia de minutos
  var diferencia = minutos_final - minutos_inicio;
  // Cálculo de horas y minutos de la diferencia
  var horas = Math.floor(diferencia / 60);
  var minutos = diferencia % 60;
  let resultFormatFloat = horas + "." + (minutos < 10 ? "0" : "") + minutos;
  let resultFormatHour = horas + ":" + (minutos < 10 ? "0" : "") + minutos;
  let obj_result = {
    resultFormatFloat: resultFormatFloat,
    resultFormatHour: resultFormatHour,
  };
  return obj_result;
}

export function GetTotalHours(infoHours) {
  var horas = infoHours.hours;
  var minutos = infoHours.minutes;
  var segundos = 0;

  horas = parseFloat(horas);
  minutos = parseFloat(minutos);
  segundos = parseFloat(segundos);

  var horas_Segundos = horas * 3600;
  var minutos_Segundos = minutos * 60;
  var segundosTotal = segundos + minutos_Segundos + horas_Segundos;

  var hours = Math.floor(segundosTotal / 3600);
  var minutes = Math.floor((segundosTotal % 3600) / 60);

  minutes = minutes < 10 ? "0" + minutes : minutes;

  var resultFormatFloat = hours + "." + minutes;
  var resultFormatHour = hours + ":" + minutes;

  var obj_result = {
    resultFormatFloat: resultFormatFloat,
    resultFormatHour: resultFormatHour,
  };
  return obj_result;
}

//---------Funciones Tablero de tiempo de carga -----PRODUCCION
export function groupByPlanta(miarray, prop) {
  return miarray.reduce(function (groups, item) {
    var val = item[prop];
    groups[val] = groups[val] || {
      U_Linea: item.U_Linea,
    };
    return groups;
  }, {});
}

export function groupByInformation(miarray, prop) {
  return miarray.reduce(function (groups, item) {
    var val = item[prop];
    groups[val] = groups[val] || {
      U_Linea: item.U_Linea,
      U_entregaCliente: item.U_entregaCliente,
      U_TipoCarga: item.U_TipoCarga,
      U_Pareja: item.U_Pareja,
      TotalHoraEHoraF: "",
      TotalTiempoCargaHoras: "",
      TiempoTotal: "",
      TotalHoraEHoraI: "",
      cantidadItems: 0,
      U_TotalDespachado: 0,
      TotalHoraIHoraF: "",
    };
    groups[val].TotalHoraEHoraF += item.TotalHoraEHoraF + ",";
    groups[val].TotalTiempoCargaHoras += item.TotalTiempoCargaHoras + ",";
    groups[val].TiempoTotal += item.TiempoTotal + ",";
    groups[val].TotalHoraEHoraI += item.TotalHoraEHoraI + ",";
    groups[val].TotalHoraIHoraF += item.TotalHoraIHoraF + ",";
    groups[val].cantidadItems += 1;
    groups[val].U_TotalDespachado += parseFloat(item.U_TotalDespachado);

    return groups;
  }, {});
}

export function ConvertStringToHour(hora) {
  let stringhour = hora.includes(":");
  let stringLength = hora.substr(hora.indexOf(":") + 1);
  if (stringhour) {
    if (stringLength.length > 1) {
      return hora;
    }

    if (stringLength.length <= 1) {
      let newHour = hora + "0";
      let d = newHour.substr(hora.indexOf(":") + 1);
      if (parseInt(d) > 60) {
        return newHour.substr(0, hora.indexOf(":")) + ":59";
      }
      if (parseInt(d) <= 59) {
        return hora + "0";
      }
    }
  }
  if (!stringhour) {
    let newHour =
      hora.length === 4
        ? hora.slice(0, -2) + ":" + hora.slice(2)
        : hora.length === 2
          ? "00:" + hora
          : hora.length === 3
            ? "0" + hora.slice(0, -2) + ":" + hora.slice(1)
            : "";
    return newHour;
  }
}

export function ConvertHourPositive(hora) {
  let stringhour = hora.includes(":");
  let stringLength = hora.substr(hora.indexOf(":") + 1);
  if (stringhour) {
    if (stringLength.length > 1) {
      let d1 = parseInt(hora) > 0 ? parseInt(hora) : "00";
      let d2 = parseInt(stringLength) > 0 ? stringLength : "00";
      return d1 + ":" + d2;
    }

    if (stringLength.length <= 1) {
      let newHour = hora + "0";
      let d = newHour.substr(hora.indexOf(":") + 1);
      if (parseInt(d) > 60) {
        return newHour.substr(0, hora.indexOf(":")) + ":59";
      }
      if (parseInt(d) <= 59) {
        return hora + "0";
      }
    }
  }
  if (!stringhour) {
    let newHour =
      hora.length === 4
        ? hora.slice(0, -2) + ":" + hora.slice(2)
        : hora.length === 2
          ? "00:" + hora
          : hora.length === 3
            ? "0" + hora.slice(0, -2) + ":" + hora.slice(1)
            : "";
    return newHour;
  }
}

export function toggleDataSeries(e) {
  if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
    e.dataSeries.visible = false;
  } else {
    e.dataSeries.visible = true;
  }
  e.chart.render();
}

export function FormatHoursGraphic(value) {
  let minutes = value.toString();
  let indexOfFirst = minutes.substr(minutes.indexOf(".") + 1);
  let newMinute = parseInt(indexOfFirst) === 0 ? ":05" :
    parseInt(indexOfFirst) === 2 ? ':20' :
      parseInt(indexOfFirst) === 3 ? ':30' :
        parseInt(indexOfFirst) === 6 ? ':58' :
          ":59";
  let hournew = parseInt(value) + newMinute + " Hrs";
  return hournew;

}

//funcion proyectado mensual tablero ventas por familia 
export function get_color_tableroHome(value1, value2) {
  let newvalue =  isFinite(value1 / value2 * 100) === false ? 0  : Number.parseFloat(
    value1 / value2 * 100
  ).toFixed(0) 
  return parseInt(newvalue);

}